// Module
var code = "<h2 id=\"beware-of-debt-relief-organizations\">Beware of &quot;Debt Relief&quot; Organizations</h2> <p>Learn why you shouldn&#39;t pay for assistance with your loans.</p> ";
// Exports
export default code;